export var Settings = {
    /**
     * @description Enable internal shape pooling for Graphics.
     * Used for reduce shape rebuilding after clear - filling phases.
     */
    ALLOW_INTERNAL_POOL: {
        FILLS: false,
        STROKES: false,
    },
    /**
     * @description How many clears required for caching a shapes
     */
    CLEARS_BEFORE_POOLING: 10,
    /**
     * @description Tryed to combine Pathes to one shape
     */
    ALLOW_COMBINER: {
        FILLS: true,
        // Strokes not support yet
        STROKES: false,
    },
    /**
     * @description Allow vao for elements
     */
    ALLOW_VAO: true,
    /**
     * @description Enable construct a approximation convex for triangle element.
     */
    ENABLE_CONVEX_BOUNDS: false,
    /**
     * @description Run convex filling after bounds N requiest, 0 - immedate when any bounds requested
     */
    CONVEX_MIN_REQUIEST_FOR_BUILD: 10,
    /**
     * @description Threshold for points count, that enable a hull generator
     */
    POINTS_COUNT_FOR_CONVEX: 10,
};
